import { Mongo } from "meteor/mongo";
import { Friend } from "lib";

export const Friends = new Mongo.Collection<Friend>("friends");
